function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.function.bind.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url-search-params.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/es.string.ends-with.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.symbol.iterator.js";
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var FormValidator = /*#__PURE__*/function () {
  function FormValidator(options) {
    _classCallCheck(this, FormValidator);
    var defaults = {
      form: {},
      fields: [],
      errors: [],
      password_mode: false,
      init_fields: false,
      remote_errors: []
    };
    this.options = Object.assign({}, defaults, options);
  }
  _createClass(FormValidator, [{
    key: "initialize",
    value: function initialize() {
      this.$form = $(this.options.form.id);
      if (!this.$form.length) return false;
      this.$errors = $(this.options.form.errors);
      this.$btn_submit = $(this.options.form.btn_submit);
      this.form = this.$form[0];
      this.fields = this.options.fields;
      this.errors = this.options.errors;
      this.remote_errors = this.options.remote_errors;
      this.$btn_submit.on('click', this.emptyErrors.bind(this));
      this.initFields();
      this.initPasswordMode();
      this.emptyErrors();
      this.validateRemoteErrors();
      this.validateOnSubmit();
      return true;
    }
  }, {
    key: "initFields",
    value: function initFields() {
      if (!this.options.init_fields) {
        return;
      }
      var $select;
      this.options.init_fields.forEach(function (field) {
        switch (field.type) {
          case 'select2':
            $select = $("select[name=\"".concat(field.name, "\"]"));
            if ($select.length) {
              var pars = field.params || {};
              if (field.selecting) {
                $select.on("select2:selecting", field.selecting);
              }

              //if (field.name=="pharmacy") {

              //pars.matcher = this.matchCustom

              //pars.minimumInputLength = 2

              // $select.on("select2:selecting", function (e) {

              //     if ( e.params.args.data.id == -1) {

              //         $('#actionbox').modal('show')

              //         e.preventDefault()

              //         return false

              //     }

              // });

              //}

              $select.select2(pars);
            }
            break;
          default:
            break;
        }
      });
    }
  }, {
    key: "initPasswordMode",
    value: function initPasswordMode() {
      if (!this.options.password_mode) {
        this.is_password_accettable = true;
        return;
      }
      if (typeof this.options.password_mode.validator === 'function') {
        this.$password = $(this.options.password_mode.field);
        return;
      }
      var self = this;
      this.is_password_accettable = false;
      this.$password = $(this.options.password_mode.field);
      this.$password.password(this.options.password_mode.options);
      this.$password.on('password.score', function (e, score) {
        //console.debug( 'Current score is %d', score );
        self.is_password_accettable = score >= self.options.password_mode.acceptable_score;
      });
    }
  }, {
    key: "emptyErrors",
    value: function emptyErrors() {
      this.$errors.removeClass('errors').empty();
    }
  }, {
    key: "addError",
    value: function addError(error, field) {
      this.$errors.append("<span class=\"aa-".concat(field, "\">").concat(error, "</span>"));
      this.$errors.addClass('errors');
    }
  }, {
    key: "validateRemoteErrors",
    value: function validateRemoteErrors() {
      var _this = this;
      if (!this.remote_errors) return;
      var searchParams = new URLSearchParams(window.location.search);
      this.remote_errors.forEach(function (error) {
        if (searchParams.has(error.param) && searchParams.get(error.param) == error.value) {
          if (typeof error.message === 'string') {
            _this.addError(error.message, 'remote');
          } else if (typeof error.message === 'function') {
            _this.addError(error.message(searchParams), 'remote');
          }
        }
      });
    }
  }, {
    key: "validateOnSubmit",
    value: function validateOnSubmit() {
      var self = this;
      this.form.addEventListener('submit', function (e) {
        //e.preventDefault()

        var is_valid = true;
        var input, field_type, is_valid_field;
        self.fields.forEach(function (field) {
          input = document.querySelector("input[name=\"".concat(field, "\"]"));
          field_type = 'input';
          if (!input) {
            input = document.querySelector("select[name=\"".concat(field, "\"]"));
            field_type = 'select';
          }
          is_valid_field = self.validateFields(input, field, field_type);
          is_valid = is_valid && is_valid_field;
        });
        console.debug('validate fields is_valid', is_valid);
        var is_valid_captcha = is_valid && self.validateRecaptcha();
        console.debug('is_valid_captcha', is_valid_captcha);
        is_valid = is_valid && is_valid_captcha;
        console.debug('all is_valid', is_valid);
        if (!is_valid) {
          e.preventDefault();
          return false;
        }
      });
    }
  }, {
    key: "validateFields",
    value: function validateFields(input, field, field_type) {
      console.debug('validate field', field, field_type);
      switch (field) {
        case 'remember':
        case 'remember2':
          if (!$("#".concat(field)).prop("checked")) {
            this.addError(this.errors[field], field);
            return false;
          }
          break;
        case 'password':
          if (!this.validatePassword(input.value.trim())) {
            return false;
          }
          break;
        case 'password_check':
          if (input.value.trim() !== this.$password.val()) {
            this.addError(this.errors[field], field);
            return false;
          }
          break;
        case 'email':
          if (!this.validateEmail(input.value.trim())) {
            this.addError(this.errors[field], field);
            return false;
          }
          break;
        default:
          if (field_type === 'select') {
            if (input.value === "") {
              this.addError(this.errors[field], field);
              return false;
            }
          } else if (field.endsWith('_check')) {
            var sourceField = field.substr(0, field.length - 6);
            if (input.value.trim() !== this.$form.find("[name=".concat(sourceField, "]")).val()) {
              this.addError(this.errors[field], field);
              return false;
            }
          } else {
            if (input.value.trim() === "") {
              this.addError(this.errors[field], field);
              return false;
            }
          }
      }
      console.debug('field valid', field, field_type);
      return true;
    }
  }, {
    key: "validateEmail",
    value: function validateEmail(email) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    }
  }, {
    key: "validatePassword",
    value: function validatePassword(password) {
      if (this.options.password_mode.validator) {
        this.is_password_accettable = this.options.password_mode.validator(password);
      }
      if (!this.is_password_accettable) {
        this.addError(this.errors.is_password_accettable, 'accettable');
        return false;
      }
      return true;
    }
  }, {
    key: "validateRecaptcha",
    value: function validateRecaptcha() {
      if (!this.options.form.recaptcha) return true;
      var formId = this.options.form.id.replace('#', '');
      var form = document.getElementById(formId);
      var init_fields = this.options.init_fields;
      grecaptcha.ready(function () {
        grecaptcha.execute(window.V3_SITE_KEY, {
          action: 'homepage'
        }).then(function (token) {
          var response = document.createElement('input');
          response.type = 'hidden';
          response.name = 'g-recaptcha-response';
          response.value = token;
          var action = document.createElement('input');
          action.type = 'hidden';
          action.name = 'action';
          action.value = 'homepage';
          form.prepend(response, action);
          if (init_fields) {
            for (var i = 0; i < init_fields.length; i++) {
              // Disables Select2 for form cloning
              if (init_fields[i].type === 'select2') {
                var $selectElement = $("[name=".concat(init_fields[i].name, "]"));
                var selectValue = $selectElement.val();
                $selectElement.select2('destroy').append("<option selected value=\"".concat(selectValue, "\">").concat(selectValue, "</option>"));
              }
            }
          }

          // Set selected option for select on DOM
          $('select', form).each(function () {
            var $currentSelect = $(this);
            var currentSelectVal = $currentSelect.val();
            if (currentSelectVal) {
              $("option[value=\"".concat(currentSelectVal, "\"]"), $currentSelect).attr("selected", true);
            }
          });
          var formClone = form.cloneNode(true);
          form.parentNode.replaceChild(formClone, form);
          document.getElementById(formId).submit();
        });
      });
      return false;
    }
  }]);
  return FormValidator;
}();
export { FormValidator as default };